import { useServicesContext } from "@modules/core/services/services.context"
import { useSuspenseQuery } from "@tanstack/react-query"
import { BoxSessionDetailsEntity } from "@/modules/boxSlotSession/entities/boxSessionEntity"
import { boxSlotSessionKeys } from "@/modules/boxSlotSession/gateway/boxSlotSessionKey"

export function useBoxSlotScheduledSessionsInRange(programId: string, startDate: Date, endDate: Date) {
  const { boxSlotApi } = useServicesContext()
  return useSuspenseQuery({
    queryKey: boxSlotSessionKeys.scheduledSessionsInRange(programId, startDate, endDate),
    queryFn: async () => {
      const result = await boxSlotApi.getScheduledSessions(programId, startDate, endDate)
      return result.map((session) => BoxSessionDetailsEntity.fromDto(session))
    },
  })
}

export const useBoxSlotSessionScheduled = (programmationId: string, date: Date) => {
  const { boxSlotApi } = useServicesContext()

  return useSuspenseQuery({
    queryKey: boxSlotSessionKeys.scheduledSession(programmationId, date),
    queryFn: async () => {
      const sessionDetailsDto = await boxSlotApi.getScheduledSession(programmationId, date)
      return BoxSessionDetailsEntity.fromDto(sessionDetailsDto)
    },
  })
}
